import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { CASTOR_API_URL } from '../api-config';
import { AuthService } from '../auth/auth.service';

export interface RunnerCustomer {
  customerId: string;
  name: string;
  email?: string;
}

@Injectable({ providedIn: 'root' })
export class CustomerLookupService {
  private http = inject(HttpClient);
  private auth = inject(AuthService);

  private async headers(): Promise<Record<string, string>> {
    const token = await this.auth.getIdToken();
    const h: Record<string, string> = { 'Content-Type': 'application/json' };
    if (token) h['Authorization'] = token;
    return h;
  }

  async getByEmail(email: string): Promise<RunnerCustomer | null> {
    const trimmed = email.trim();
    if (!trimmed) return null;

    const headers = await this.headers();
    const params = new HttpParams().set('email', trimmed);
    try {
      const res = await firstValueFrom(
        this.http.get<RunnerCustomer>(`${CASTOR_API_URL}/customers/by-email`, { headers, params })
      );
      if (!res?.name || !res.customerId) {
        return null;
      }
      return res;
    } catch {
      return null;
    }
  }
}

